import ReactMarkdown, { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

import * as S from './MessageMarkdown.styles'
import { toMessageMarkdown } from './MessageMarkdown.utils'

const PLUGINS = [remarkGfm]

const ALLOWED_ELEMENTS = ['p', 'strong', 'em', 'del', 'a', 'br', 'ul', 'ol', 'li', 'code']

const COMPONENTS: Components = {
  a: ({ href, children }) => {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  },
}

interface MessageMarkdownProps {
  body?: string | null
}

export const MessageMarkdown = ({ body }: MessageMarkdownProps) => {
  return (
    <S.Markdown>
      <ReactMarkdown
        remarkPlugins={PLUGINS}
        allowedElements={ALLOWED_ELEMENTS}
        components={COMPONENTS}
        unwrapDisallowed
      >
        {toMessageMarkdown(body)}
      </ReactMarkdown>
    </S.Markdown>
  )
}
